import { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import { Button, Col, Form, Input, Row, Select, message } from "antd";
import { serverFetch } from "@/server";
import { isMobile, menuSize } from "@/extensions/design";
import "./requisites.css";

const companySnoOptions = [
  { value: 1, label: "ОСН" },
  { value: 2, label: "УСН доходы" },
  { value: 3, label: "УСН доходы-расходы" },
  { value: 4, label: "Патент" },
];

const Requisites = forwardRef(({ onHeaderStateChange, onHeaderLoadingChange }, ref) => {
  const [loading, setLoading] = useState(false);
  const [modified, setModified] = useState(false);
  const [item, setItem] = useState();
  const [values, setValues] = useState({});
  const changedValuesRef = useRef({});

  const notifyHeader = () => {
    onHeaderStateChange?.(modified);
    onHeaderLoadingChange?.(loading);
  };

  const getSaveData = () => ({ ...item, ...changedValuesRef.current });

  const getData = () => {
    setLoading(true);
    serverFetch("Company/Current")
      .then(data => {
        setItem(data);
        setValues(data ?? {});
        changedValuesRef.current = {};
        setModified(false);
        setLoading(false);
        notifyHeader();
      })
      .catch(e => {
        setLoading(false);
        notifyHeader();
        message.error(e.userMessage);
      });
  };

  useEffect(getData, []);

  const onFieldChange = (fieldName, value) => {
    const nextValue = value ?? "";
    setValues(prev => ({ ...prev, [fieldName]: nextValue }));
    changedValuesRef.current = { ...changedValuesRef.current, [fieldName]: nextValue === "" ? null : nextValue };
    setModified(true);
    onHeaderStateChange?.(true);
  };

  const onSave = () => {
    setLoading(true);
    serverFetch("company", { method: "PUT", bodyData: getSaveData() })
      .then(() => {
        setItem(prev => ({ ...prev, ...changedValuesRef.current }));
        changedValuesRef.current = {};
        setModified(false);
        setLoading(false);
        message.success("Сохранено");
        onHeaderStateChange?.(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
        onHeaderStateChange?.(modified);
      });
  };

  useImperativeHandle(ref, () => ({
    save: onSave,
    isModified: () => modified,
  }));

  const getInputProps = (fieldName) => ({
    value: values[fieldName] ?? "",
    onChange: e => onFieldChange(fieldName, e.target.value),
  });

  const formContent = (
    <>
      <Form.Item label="Полн.наименование">
        <Input maxLength={200} {...getInputProps("fullName")} />
      </Form.Item>
      <Form.Item label="Юридический адрес">
        <Input maxLength={300} {...getInputProps("legalAddress")} />
      </Form.Item>
      <Form.Item label="Фактический адрес">
        <Input maxLength={300} {...getInputProps("addressFact")} />
      </Form.Item>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Телефон">
            <Input maxLength={50} {...getInputProps("legalEntityPhone")} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="ИНН/КПП">
            <Input maxLength={50} {...getInputProps("inn")} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item label="Система налогообложения">
        <Select
          allowClear
          options={companySnoOptions}
          value={values.sno || undefined}
          onChange={value => onFieldChange("sno", value ?? 0)}
          placeholder="Выберите значение"
        />
      </Form.Item>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Расчетный счет">
            <Input maxLength={50} {...getInputProps("rschet")} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="к/счет">
            <Input maxLength={50} {...getInputProps("kschet")} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="БИК">
            <Input maxLength={50} {...getInputProps("bik")} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="ОГРН">
            <Input maxLength={50} {...getInputProps("ogrn")} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item label="Банк">
        <Input maxLength={200} {...getInputProps("bank")} />
      </Form.Item>
      <Form.Item label="ФИО руководителя">
        <Input maxLength={200} {...getInputProps("sotrName")} />
      </Form.Item>
      <Form.Item label="Должность">
        <Input maxLength={200} {...getInputProps("dolj")} />
      </Form.Item>
      <Form.Item label="ФИО бухгалтера">
        <Input maxLength={200} {...getInputProps("buhName")} />
      </Form.Item>
    </>
  );

  return (
    <div className="requisites-main">
      <div className={isMobile ? "requisites-mobile-scroll" : undefined} style={isMobile ? { height: window.innerHeight - menuSize - 30 } : undefined}>
        <Form className="requisites-form" labelCol={isMobile ? { xs: 8 } : { flex: "160px" }} wrapperCol={isMobile ? { xs: 16 } : { flex: 1 }} labelAlign="right"
          layout="horizontal" colon={false} disabled={loading}>
          {formContent}
        </Form>
        {!isMobile && <Button className="sport-btn-req" onClick={onSave} loading={loading} disabled={!modified}> Сохранить </Button>}
      </div>
    </div>
  );
});

Requisites.displayName = "Requisites";

export default Requisites;
